function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import { repositoryName } from "@/views/repository/config";
import PatchDialog from "@/components/PatchDialog/index.vue";
var BatchUploader = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(BatchUploader, Vue1);
    var _super = _createSuper(BatchUploader);
    function BatchUploader() {
        _classCallCheck(this, BatchUploader);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isBatch = true;
        _this.editType = 0;
        _this.dialogConfig = {
            loading: false,
            visible: false,
            title: "",
            width: "1000px"
        };
        return _this;
    }
    var _proto = BatchUploader.prototype;
    _proto.handleDialogConfigChange = function handleDialogConfigChange(val) {
        if (val === false) {
            this.dialogConfig.loading = false;
            this.$emit("close");
        }
    };
    _proto.handleDialogTitleChange = function handleDialogTitleChange(val) {
        this.dialogConfig.title = val;
    };
    _proto.setErrorMessage = function setErrorMessage(data) {
        this.patchDialog.setErrorMessage(data);
    };
    _proto.resetForm = function resetForm() {};
    _proto.close = function close() {
        var _this = this;
        this.dialogConfig.visible = false;
        this.$nextTick(function() {
            _this.dialogConfig.loading = false;
        });
    };
    _proto.show = function show() {
        var _this = this;
        this.resetForm();
        this.dialogConfig.visible = true;
        this.$nextTick(function() {
            _this.dialogConfig.loading = false;
        });
    };
    _proto.handleSubmit = function handleSubmit(data) {
        this.dialogConfig.loading = true;
        this.$emit("submit", data);
    };
    _createClass(BatchUploader, [
        {
            key: "libName",
            get: function get() {
                var _this = this;
                return (repositoryName.find(function(e) {
                    return e.value === Number(_this.resourceType);
                }) || {}).label;
            }
        },
        {
            key: "dialogTitle",
            get: function get() {
                if (this.editType === 1) return "\u7F16\u8F91" + this.libName;
                return "\u6DFB\u52A0" + this.libName;
            }
        }
    ]);
    return BatchUploader;
}(Vue);
__decorate([
    Ref()
], BatchUploader.prototype, "patchDialog", void 0);
__decorate([
    Prop({
        default: "material"
    })
], BatchUploader.prototype, "uploaderType", void 0);
__decorate([
    Prop({
        default: 0,
        required: true
    })
], BatchUploader.prototype, "resourceType", void 0);
__decorate([
    Watch("dialogConfig.visible")
], BatchUploader.prototype, "handleDialogConfigChange", null);
__decorate([
    Watch("dialogTitle", {
        immediate: true
    })
], BatchUploader.prototype, "handleDialogTitleChange", null);
BatchUploader = __decorate([
    Component({
        components: {
            PatchDialog: PatchDialog
        }
    })
], BatchUploader);
export { BatchUploader as default };
